import React from 'react';
import { HStack, Link, IconButton, Box } from '@chakra-ui/react';

import { useColorModeValue } from './chakra-ui/color-mode';
import { SOCIAL_LINKS_CONFIG } from '../constants/constants';
import { COLORS } from '../theme';

function SocialMediaLinks({ flexDirection = 'row', noBackground = true }) {
  const glassBg = useColorModeValue(
    COLORS.glass.bg.light,
    COLORS.glass.bg.dark
  );
  const glassBorder = useColorModeValue(
    'transparent',
    COLORS.glass.border.dark
  );
  const glassShadow = useColorModeValue(
    '0 4px 12px rgba(0, 0, 0, 0.08)',
    COLORS.glass.shadow.dark
  );
  const iconColor = useColorModeValue('gray.700', 'white');

  return (
    <HStack
      spacing={flexDirection === 'column' ? 4 : 6}
      flexWrap="wrap"
      justify="center"
      flexDirection={flexDirection}
      p={flexDirection === 'column' ? 3 : 2}
      borderRadius="full"
      boxShadow={noBackground ? 'none' : glassShadow}
      bg={noBackground ? 'transparent' : glassBg}
      backdropFilter={noBackground ? 'none' : `blur(${COLORS.glass.blur})`}
      border={noBackground ? 'none' : '1px solid'}
      borderColor={noBackground ? 'transparent' : glassBorder}
      transition="all 0.3s"
    >
      {SOCIAL_LINKS_CONFIG.map(
        ({ href, colorScheme, color, hoverBg, ariaLabel, icon }) => (
          <Link
            key={href}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton
              colorScheme={colorScheme}
              variant="ghost"
              size={'xl'}
              color={noBackground ? color : iconColor}
              _hover={{
                transform: 'scale(1.2) translateY(-2px)',
                bg: hoverBg,
                color: color,
                shadow: 'sm'
              }}
              transition="all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
              aria-label={ariaLabel}
              borderRadius="full"
            >
              <span style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: flexDirection === 'column' ? '28px' : '32px',
                height: flexDirection === 'column' ? '28px' : '32px',
                lineHeight: 0
              }}>
                {React.cloneElement(icon, {
                  style: {
                    width: '100%',
                    height: '100%'
                  }
                })}
              </span>
            </IconButton>
          </Link>
        )
      )}
    </HStack>
  );
}

export default SocialMediaLinks;
